import { MarketingFooterMinimal } from "@/components/MarketingFooterMinimal";
import { Picture } from "@/components/Picture";
import { ButtonLink } from "@/components/ui/button";
import footerFlowerImg from "@/images/footer-flower.webp?w=500;900;1200&format=avif;webp;jpg&as=picture";
import footerGuy from "@/images/footer-guy.webp?w=500;900;1200&format=avif;webp;jpg&as=picture";
import orangeFlower from "@/images/orange-flower.png?w=500;900;1200&format=avif;webp;jpg&as=picture";
import yellowFlower from "@/images/yellow-flower.png?w=500;900;1200&format=avif;webp;jpg&as=picture";


interface MarketingFooterProps {
  variant?: "default" | "slate";
  showStartSection?: boolean;
  showCarrot?: boolean;
}

export default function MarketingFooter({
  variant = "default",
  showStartSection = true,
  showCarrot = true,
}: MarketingFooterProps) {
  return (
    <footer className="relative z-1 flex flex-col">
      {showStartSection && (
        <div
          className={[
            "relative @container overflow-hidden",
            variant === "default"
              ? "bg-teal-11 dark:bg-tealdark-10 text-teal-contrast dark:text-tealdark-contrast"
              : variant === "slate"
              ? "bg-slate-7 dark:bg-slatedark-7 text-slate-normal"
              : "",
          ].join(" ")}
        >
          <Picture
            src={footerFlowerImg}
            alt=""
            className="hidden md:flex h-auto w-[25%] max-h-[80%] absolute left-8 bottom-0"
          />
          <Picture
            src={yellowFlower}
            alt=""
            className="hidden md:flex h-auto w-[30%] max-h-[80%] absolute -right-4 bottom-0"
          />
          <Picture
            src={orangeFlower}
            alt=""
            className="block md:hidden max-h-[30cqh] max-w-[15cqw] w-auto absolute left-4 -bottom-4"
          />
          <div className="container mx-auto flex flex-col md:flex-row gap-12 md:gap-16 w-full px-8 pt-12 md:pt-20 md:px-12">
            <div className="flex-1 shrink-0">
              <div className="@container">
                <div className="flex flex-col items-center gap-2 pb-14 w-full">
                  <div className="instrument-serif italic text-[8cqw] md:text-[3cqw] mb-[4cqh]">
                    What are you waiting for?
                  </div>

                  <div className="mb-6 md:mb-10 flex flex-col sharp-grotesk text-[16cqw] md:text-[7cqw] leading-[1.1]">
                    <div>
                      <>
                        {/* @prettier-ignore */}
                        <span>Let's ge</span>
                        <span className="relative @container inline-table">
                          <span>t</span>
                          <span className="absolute top-0 -translate-y-[71%] left-[-18%] right-0">
                            <Picture
                              src={footerGuy}
                              alt=""
                              className="w-[9cqw]"
                            />
                          </span>
                        </span>
                      </>
                    </div>
                    <div>building.</div>
                  </div>

                  <div className="flex flex-col gap-6 items-center justify-between shrink-1 md:max-w-[25vw]">
                    <div className="font-medium uppercase text-sm">
                      Join 5,000+ curators
                    </div>
                    <ButtonLink to="/login" size="lg">
                      Start building free
                    </ButtonLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <MarketingFooterMinimal showCarrot={showCarrot} />
    </footer>
  );
}
